/* eslint-disable @typescript-eslint/no-var-requires */
export const HeaderImage = require("../resources/img/logo.png");
export const HeaderImagePragathi = require("../resources/img/logo_pragathi.jpeg");

export const AppSpecificList:any ={
    'SEMINIS' :  require("../resources/img/logo_pragathi.jpeg"),
    'BRP' : require("../resources/img/logo.png")
};
export const AppSpecificMsg:any ={
    'SEMINIS' :  'Complete Your KYC',
    'BRP' : 'Complete Your KYC'
}

export const AppSpecificName:any = {
    'SEMINIS': 'SEMINIS',
    'BRP': 'BRP'
}
